import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { getApps } from '../../ducks/apps'
import { getCurrentUser } from '../../ducks/users'
import Button from '../Shared/Button'
import WizardFooter from './WizardFooter'
import WrappedSelect from '../Shared/Forms/WrappedSelect'
import WrappedRadio from '../Shared/Forms/WrappedRadio'
import { FORM_NAME } from './shared'

const WizardFormAdvancedPage = props => {
  const { handleSubmit, datasourceType, apps, user } = props
  const showAppOptions = datasourceType === 'copy'

  const enableExternalUsers = user.developer

  const externalUsersLabel = enableExternalUsers
    ? 'Use External Users Database and Authentication (Beta)'
    : 'Use External Users Database and Authentication (Coming Soon!)'

  return (
    <>
      <form
        id="new-app-advanced-form"
        className="new-app-form"
        onSubmit={handleSubmit}
      >
        <div className="new-app-advanced-form-title">Advanced Options</div>
        <div className="new-app-advanced-settings">
          <div className="new-app-datasource-help">
            How do you want to set up your data?
          </div>
          <Field
            className="new-app-datasource-option"
            component={WrappedRadio}
            styled
            name="datasourceType"
            radioValue="database"
            label="Create New Database"
          />
          <Field
            className="new-app-datasource-option"
            component={WrappedRadio}
            styled
            name="datasourceType"
            radioValue="copy"
            disabled={apps.length === 0}
            label="Share Database with An Existing App..."
          />
          <Field
            className="new-app-datasource-option"
            component={WrappedRadio}
            styled
            name="datasourceType"
            radioValue="externalUsers"
            label={externalUsersLabel}
            disabled={!enableExternalUsers}
          />
          {showAppOptions ? (
            <div className="new-app-datasource-app-select">
              <Field
                autoSelect
                component={WrappedSelect}
                name="datasourceAppId"
                options={apps.map(app => ({
                  label: app.name,
                  value: app.id,
                }))}
                placeholder="Select App..."
              />
            </div>
          ) : null}
        </div>
      </form>
      <WizardFooter>
        <Button
          className="next align-right"
          type="submit"
          form="new-app-advanced-form"
        >
          Done
        </Button>
      </WizardFooter>
    </>
  )
}

const mapStateToProps = state => {
  const selector = formValueSelector(FORM_NAME)

  return {
    datasourceType: selector(state, 'datasourceType'),
    apps: getApps(state),
    user: getCurrentUser(state),
  }
}

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(connect(mapStateToProps)(WizardFormAdvancedPage))
